import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import 'firebase/compat/firestore';
import 'firebase/compat/database';
import 'firebase/compat/storage';

const config = require('./AppConfig.json');

const env = process.env;

// Firebase
const firebaseConfig = {
  apiKey: env.REACT_APP_FIREBASE_API_KEY || config.firebase.apiKey,
  authDomain: env.REACT_APP_FIREBASE_AUTH_DOMAIN || config.firebase.authDomain,
  databaseURL: env.REACT_APP_FIREBASE_DATABASE_URL || config.firebase.databaseURL,
  projectId: env.REACT_APP_FIREBASE_PROJECT_ID || config.firebase.projectId,
  storageBucket: env.REACT_APP_FIREBASE_STORAGE_BUCKET || config.firebase.storageBucket,
  messagingSenderId: env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || config.firebase.messagingSenderId,
  appId: env.REACT_APP_FIREBASE_APP_ID || config.firebase.appId,
};

// Safe local diagnostic log. It does not print the full API key.
if (process.env.NODE_ENV === 'development') {
  console.info('[Firebase Config]', {
    hasApiKey: Boolean(firebaseConfig.apiKey),
    apiKeyLength: firebaseConfig.apiKey ? firebaseConfig.apiKey.length : 0,
    apiKeyStart: firebaseConfig.apiKey ? firebaseConfig.apiKey.substring(0, 8) : null,
    authDomain: firebaseConfig.authDomain,
    databaseURL: firebaseConfig.databaseURL,
    projectId: firebaseConfig.projectId,
    storageBucket: firebaseConfig.storageBucket,
  });
}

export const firebase_app = firebase.apps.length
  ? firebase.app()
  : firebase.initializeApp(firebaseConfig);

export const googleProvider = new firebase.auth.GoogleAuthProvider();
export const facebookProvider = new firebase.auth.FacebookAuthProvider();
export const twitterProvider = new firebase.auth.TwitterAuthProvider();
export const githubProvider = new firebase.auth.GithubAuthProvider();
export const emailProvider = new firebase.auth.EmailAuthProvider();

export const db = firebase.firestore();
export const firebase_rdb = firebase.database().ref();

// Auth0
export const auth0 = {
  domain: env.REACT_APP_AUTH0_DOMAIN || config.auth0.domain,
  clientId: env.REACT_APP_AUTH0_CLIENT_ID || config.auth0.clientID,
  redirectUri: env.REACT_APP_AUTH0_REDIRECT_URI || config.auth0.redirectUri,
};

// Captcha
export const reCaptchaKey = env.REACT_APP_RECAPTCHA_SITE_KEY || config.recaptchaV3.siteKey;
